import axios, { AxiosError } from 'axios';
import toast from 'react-hot-toast';

const errorInterceptor = () =>
  axios.interceptors.response.use(
    (response) => response,
    async (err: AxiosError) => {
      toast.error('Error has occured');
      return Promise.reject(err);
    }
  );

export default errorInterceptor;
